// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payout-noBorder-xS369 {
	border: 0px none !important;
}

.Payout-rowBorder-rlnAA {
	border-bottom: 1px solid var(--primary-border);
}

.Payout-titleText-ZsTwV {
	margin: 0px 0px 18px 0px;
	font-size: 22px;
}

.Payout-textTruncate-XFcqr {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.Payout-textMuted-fipcA {
	color: var(--secondary-foreground);
}

.Payout-textSpace-Zp53f {
	margin-left: 10px;
	color: var(--primary-bg);
}

.Payout-textSpace-Zp53f:hover {
	color: var(--primary-bg);
}

.Payout-radioText-oM0v_ {
	font-size: 14px;
	font-weight: normal;
	display: inline;
	padding-right: 5px;
}

.Payout-btnRight-RgqBn {
	margin-right: 30px;
}

.Payout-displayInline-hRums {
	display: inline-block;
}

.Payout-infoBox-cBhpA {
	font-size: 14px;
	color: var(--secondary-foreground);
}

.Payout-transparentText-daSyx {
	/* color: transparent !important; */
}

.Payout-marginLeft-gEo_Z {
	margin-right: 18px;
	display: inline-block;
}

.Payout-toolTipIcon-Gx9k6 {
	width: 100%;
	max-width: 16px;
	margin: 0px 0px 2px 4px;
}

.Payout-linkText-v6T7G,
.Payout-linkText-v6T7G:hover,
.Payout-linkText-v6T7G:focus {
	color: var(--primary-link-foreground);
}

.Payout-displayGrid-AAzxK {
	display: grid;
	grid-template-columns: 48% 48%;
	-webkit-column-gap: 27px;
	   -moz-column-gap: 27px;
	        column-gap: 27px;
}

.Payout-displayBlock-R5mdz {
	display: block;
}

.Payout-stripeLink-rW6H1,
.Payout-stripeLink-rW6H1:hover,
.Payout-stripeLink-rW6H1:focus {
	color: var(--primary-link-foreground);
}

.Payout-plusIcon-mQeIk {
	margin: 0px 6px 2px 0px;
	width: 14px;
	height: 14px;
}

.Payout-addBtn-nlfHX {
	border-radius: 23px !important;
}

.Payout-textCenter-Oiyg5 {
	text-align: center !important;
}

.Payout-methodsFlex-la_Ny {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-column-gap: 5px;
	   -moz-column-gap: 5px;
	        column-gap: 5px;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.Payout-VisibleXS-mcJc8 {
	display: none;
}

.Payout-labelText-CTT7E {
	display: inline-block;
	max-width: 100%;
	margin-bottom: 5px !important;
	font-weight: 700 !important;
	font-size: 14px !important;
}

@media screen and (max-width: 767px) {
	.Payout-displayGrid-AAzxK {
		grid-template-columns: 100%;
	}

	.Payout-VisibleXS-mcJc8 {
		display: block;
	}

	.Payout-hiddenXS-Z2EyO {
		display: none !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Payout/Payout.css"],"names":[],"mappings":"AAAA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,uBAAuB;AACxB;;AAEA;;;CAGC,qCAAqC;AACtC;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,qCAAqC;AACtC;;AAEA;CACC,uBAAuB;CACvB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,6BAA6B;CAC7B,2BAA2B;CAC3B,0BAA0B;AAC3B;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,wBAAwB;CACzB;AACD","sourcesContent":[".noBorder {\n\tborder: 0px none !important;\n}\n\n.rowBorder {\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.titleText {\n\tmargin: 0px 0px 18px 0px;\n\tfont-size: 22px;\n}\n\n.textTruncate {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.textMuted {\n\tcolor: var(--secondary-foreground);\n}\n\n.textSpace {\n\tmargin-left: 10px;\n\tcolor: var(--primary-bg);\n}\n\n.textSpace:hover {\n\tcolor: var(--primary-bg);\n}\n\n.radioText {\n\tfont-size: 14px;\n\tfont-weight: normal;\n\tdisplay: inline;\n\tpadding-right: 5px;\n}\n\n.btnRight {\n\tmargin-right: 30px;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n.infoBox {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.transparentText {\n\t/* color: transparent !important; */\n}\n\n.marginLeft {\n\tmargin-right: 18px;\n\tdisplay: inline-block;\n}\n\n.toolTipIcon {\n\twidth: 100%;\n\tmax-width: 16px;\n\tmargin: 0px 0px 2px 4px;\n}\n\n.linkText,\n.linkText:hover,\n.linkText:focus {\n\tcolor: var(--primary-link-foreground);\n}\n\n.displayGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 48% 48%;\n\tcolumn-gap: 27px;\n}\n\n.displayBlock {\n\tdisplay: block;\n}\n\n.stripeLink,\n.stripeLink:hover,\n.stripeLink:focus {\n\tcolor: var(--primary-link-foreground);\n}\n\n.plusIcon {\n\tmargin: 0px 6px 2px 0px;\n\twidth: 14px;\n\theight: 14px;\n}\n\n.addBtn {\n\tborder-radius: 23px !important;\n}\n\n.textCenter {\n\ttext-align: center !important;\n}\n\n.methodsFlex {\n\tdisplay: flex;\n\tcolumn-gap: 5px;\n\talign-items: center;\n}\n\n.VisibleXS {\n\tdisplay: none;\n}\n\n.labelText {\n\tdisplay: inline-block;\n\tmax-width: 100%;\n\tmargin-bottom: 5px !important;\n\tfont-weight: 700 !important;\n\tfont-size: 14px !important;\n}\n\n@media screen and (max-width: 767px) {\n\t.displayGrid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.VisibleXS {\n\t\tdisplay: block;\n\t}\n\n\t.hiddenXS {\n\t\tdisplay: none !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noBorder": `Payout-noBorder-xS369`,
	"rowBorder": `Payout-rowBorder-rlnAA`,
	"titleText": `Payout-titleText-ZsTwV`,
	"textTruncate": `Payout-textTruncate-XFcqr`,
	"textMuted": `Payout-textMuted-fipcA`,
	"textSpace": `Payout-textSpace-Zp53f`,
	"radioText": `Payout-radioText-oM0v_`,
	"btnRight": `Payout-btnRight-RgqBn`,
	"displayInline": `Payout-displayInline-hRums`,
	"infoBox": `Payout-infoBox-cBhpA`,
	"transparentText": `Payout-transparentText-daSyx`,
	"marginLeft": `Payout-marginLeft-gEo_Z`,
	"toolTipIcon": `Payout-toolTipIcon-Gx9k6`,
	"linkText": `Payout-linkText-v6T7G`,
	"displayGrid": `Payout-displayGrid-AAzxK`,
	"displayBlock": `Payout-displayBlock-R5mdz`,
	"stripeLink": `Payout-stripeLink-rW6H1`,
	"plusIcon": `Payout-plusIcon-mQeIk`,
	"addBtn": `Payout-addBtn-nlfHX`,
	"textCenter": `Payout-textCenter-Oiyg5`,
	"methodsFlex": `Payout-methodsFlex-la_Ny`,
	"VisibleXS": `Payout-VisibleXS-mcJc8`,
	"labelText": `Payout-labelText-CTT7E`,
	"hiddenXS": `Payout-hiddenXS-Z2EyO`
};
module.exports = ___CSS_LOADER_EXPORT___;
